export var RegistrationPolicyVoData;
(function (RegistrationPolicyVoData) {
    RegistrationPolicyVoData["ALLOW_INVITATION"] = "ALLOW_INVITATION";
    RegistrationPolicyVoData["ALLOW_SELF_REGISTER"] = "ALLOW_SELF_REGISTER";
})(RegistrationPolicyVoData || (RegistrationPolicyVoData = {}));
//# sourceMappingURL=registration-policy-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/authentication/registration-policy-vo-data.js
// module id = 918
// module chunks = 14